const forgotPasswordPageStyles = {
  forgotPasswordLabel: {
    paddingBottom: 20,
  },
}

export default forgotPasswordPageStyles;